export default __webpack_public_path__ + "static/media/Billy.f13b6581.png";